module.exports = __webpack_public_path__ + "static/media/tom&henry.73387e78.jpg";